import { defineAction } from '~/prix'
import { z } from 'zod'
import materialDeliveryImageDeleteAction from './materialDeliveryImageDelete.action.json' with { type: 'json' }
import { materialDeliveryImageObject } from '../materialDeliveryImageObject'

const materialDeliveryImageDeleteDefinition = defineAction({
  ...materialDeliveryImageDeleteAction,
  input: materialDeliveryImageObject.pick({ id: true }),
  output: z.object({}),
})

export default materialDeliveryImageDeleteDefinition
